import React from "react";

const Loader = () => {
  return (
    <div className="loader h-[60vh]">
      <p className="heading">Loading</p>
      <div className="loading">
        <div className="load"></div>
        <div className="load"></div>
        <div className="load"></div>
        <div className="load"></div>
      </div>
    </div>
  );
};

export default Loader;
